import { Menu } from '@vaisala/rockhopper-vaisala-com-components/Menu/index';
import styles from './MenuHeader.module.scss';

export interface MenuHeaderProps {
  user: { name: string; email: string } | null;
}

/**
 * Renders user info (name and email) in the menu header section.
 * Returns null when user is not available.
 */
export function MenuHeader({ user }: Readonly<MenuHeaderProps>): JSX.Element | null {
  if (!user) {
    return null;
  }

  return (
    <Menu.Header className={styles.header}>
      <span className={styles.name}>{user.name}</span>
      <span className={styles.email}>{user.email}</span>
    </Menu.Header>
  );
}
